import { connect } from 'react-redux';
import { actions } from '../../../../../redux/modules/config/descuentos';
import ListarDescuentos from './ListarDescuentos';


const ms2p = (state) => {
  return {
    ...state.descuentos,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(ListarDescuentos);
